




























































































import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required, sameAs } from 'vuelidate/lib/validators';
import { LocalDatabaseStrategy } from '../../../libs/strategies';

export default Vue.extend({
  mixins: [validationMixin],
  data() {
    return {
      isMounted: false,
      isFormLoading: false,

      token: this.$route.query.token.toString(),

      form: {
        password: '',
        password_confirm: '',
      },
      success: false,
    };
  },
  validations: {
    form: {
      password: {
        required,
      },
      password_confirm: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },

  async mounted() {
    this.$set(this, 'isMounted', true);
  },

  methods: {
    async onSubmit() {
      this.$set(this, 'isFormLoading', true);
      try {
        await LocalDatabaseStrategy.resetPassword(
          this.token,
          this.form.password,
        );
      } catch (e) {
        console.error(e);
        return;
      } finally {
        this.$set(this, 'isFormLoading', false);
      }

      // On success, set request as success
      this.$set(this, 'success', true);
    },
  },
});
